<template>
  <div class="card-body">
    <div class="row mb-2">
      <div class="col-sm-8"></div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-row form-group">
          <label class="col-md-2 col-form-label">ค้นหาสินค้า</label>
          <div class="col-md-5">
            <div role="group" class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="filter.name"
                placeholder="ระบุรหัส Product หรือ SKU"
                v-on:keyup.enter="onFilter()"
                @input="
                  filter.name = $event.target.value.toUpperCase()
                "
              />
              <span
                class="input-group-append pointer"
                @click="onFilter()"
              >
                <span type="a" class="input-group-text btn btn-ico">
                  <i class="bx bx-search" />
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-row form-group">
          <label class="col-md-2 col-form-label"
            >รหัสกลุ่มสินค้า</label
          >
          <div class="col-md-5">
            <input
              readonly
              v-model="productId"
              type="text"
              class="form-control"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-12 col-md-9"></div>
      <div class="col-sm-12 col-md-3">
        <div class="input-group md-form form-sm text-right">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <span class="bx bx-search-alt"></span>
            </span>
          </div>
          <input
            v-model="searchProductCatalog"
            class="form-control my-0 py-1"
            type="search"
            placeholder="ค้นหา"
            aria-label="Search"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
          <b-table
            class="table table-centered table-nowrap"
            ref="productcatalogtable"
            :empty-text="'ไม่พบข้อมูล'"
            :show-empty="
              productItems === null ||
                productItems === undefined ||
                (productItems && productItems.length === 0)
            "
            :bordered="true"
            :filter="searchProductCatalog"
            :items="productItems"
            align="center"
            v-bind:fields="productcatalogTablefields"
            :perPage="pageSize"
          >
            <template v-slot:cell(index)="data">
              <div class="text-right">
                {{ (firstRowOnPage + data.index) | number }}
              </div>
            </template>
            <template v-slot:cell(inventory_status)="data">
              <span
                v-if="data.value"
                class="label"
                :class="'label-' + data.value.toLowerCase()"
                v-html="data.value"
              ></span>
            </template>
            <template v-slot:cell(sale_status)="data">
              <span
                v-if="data.value"
                class="label"
                :class="'label-' + data.value.toLowerCase()"
                v-html="data.value"
              ></span>
            </template>
            <template v-slot:head(pages)="data">
              <div :class="data.field.tdClass">
                {{ data.label }}
              </div>
              <div class="text-right">
                <!-- <input
                  v-model="pages"
                  :readonly="productItems.length === 0"
                  type="number"
                  class="form-control form-default text-right"
                  min="0"
                /> -->
              </div>
            </template>
            <template v-slot:head(remark)="data">
              <div :class="data.field.tdClass">
                {{ data.label }}
              </div>
              <div class="text-left">
                <!-- <input
                  v-model="remark"
                  :readonly="productItems.length === 0"
                  type="text"
                  class="form-control form-default text-left"
                /> -->
              </div>
            </template>
            <template v-slot:cell(pages)="data">
              <input
                v-model="productItems[data.index].pages"
                type="number"
                class="form-control form-default text-right"
                min="0"
              />
            </template>
            <template v-slot:cell(remark)="data">
              <input
                v-model="productItems[data.index].remark"
                type="text"
                class="form-control form-default"
              />
            </template>
            <template v-slot:cell(action)="data">
              <div class="text-center">
                <a
                  @click="onDeleteProductCatalog(data.item.id)"
                  class="btn btn-ico text-danger"
                  ><i class="bx bx-trash"></i
                ></a>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 text-sm-center">
        <div class="button-items">
          <button
            @click="onBeforeSave()"
            type="button"
            class="btn btn-primary"
          >
            <i class="bx bx-save" />Save
          </button>
          <button
            type="button"
            class="btn btn-light waves-effect"
            @click="onClear()"
          >
            <i
              class="bx bx-reset font-size-16 align-middle mr-2"
            ></i>
            Clear
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import productService from '@/helpers/service/product-service'
import catalogService from '@/helpers/service/catalog-service'
import productCatalogService from '@/helpers/service/product-catalog-service'
import XLSX from 'xlsx'
import moment from 'moment'
import { Workbook } from 'exceljs'
import * as fs from 'file-saver'
import { ExportFileName } from '@/helpers/utils/format-date.js'
import { eventBus } from '@/main.js'

export default {
  props: {
    mode: {
      type: String,
      default: '',
    },
    catalogIdSelected: {
      type: String,
      default: '',
    },
    listProductItems: {
      type: Array,
      default: () => [],
    },
    model: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
       pages: null,
      remark: null,
      productId: '',
      typeId: '',
      typeName: '',
      catalogId: '',
      catalogName: '',
      reloadCatalogType: false,
      reloadCatalog: false,
      file: null,
      // fileName: '',
      exportData: [
        {
          'รหัสสินค้า (OFM)': '',
          เลขหน้า: '',
          หมายเหตุเพิ่มเติม: '',
        },
      ],
      toggle: false,
      filter: {
        name: '',
      },
      searchProductCatalog: null,
      firstRowOnPage: 1,
      pageSize: 999999,
      pageNo: 1,
      productItems: [],
      tempProductItems: [],
      productcatalogTablefields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
        },
        {
          key: 'sku_code_ofm',
          label: 'รหัสสินค้า (OFM)',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'product_display_name.th',
          label: 'ชื่อสินค้า',
          sortable: true,
        },
        {
          key: 'inventory_status',
          label: 'สถานะสินค้า',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sale_status',
          label: 'สถานะการขาย',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'pages',
          label: 'เลขหน้า',
          tdClass: 'text-center',
          thStyle: 'width:120px',
        },
        {
          key: 'remark',
          label: 'หมายเหตุเพิ่มเติม',
          tdClass: 'text-center',
        },
        {
          key: 'error_message',
          label: 'Error Message',
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      isLoading: false,
      modeData: 'Create',
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  mounted: function() {
    
  },
  methods: {
   async onFilter() {
      if (this.filter.name) {
        this.productItems = []
        this.tempProductItems = []
        this.pages = null
        this.remark = null
        let params = new URLSearchParams()
        params.append('pageNo', 1)
        params.append('pageSize', 9999)
        params.append('sort', 'product_id')
        params.append('product_id_or_sku_code_ofm', this.filter.name.trim())
        let result = await productService.getProductSkuListAsync(params)
        if (result.status === 200 || result.status === 201) {
          if (result.data.items && result.data.items.length === 0) {
            this.$utils.notification('warning', 'ไม่พบรหัสสินค้าในระบบ', 2000)
          } else {
            result.data.items.forEach(element => {
              var displayName = element.product_names.find(
                f => f.type === 'Online'
              ).display_name
              var tempItem = {
                id: element.id,
                product_id: element.product_id,
                sku_code_ofm: element.id,
                product_display_name: {
                  th: displayName.th,
                  en: displayName.en,
                },
                inventory_status: element.product_status.inventory,
                sale_status: element.product_status.sale,
                pages: null,
                remark: null,
                error_message: element.error_message,
                is_error: element.is_error,
              }
              this.productItems.push(tempItem)
            })

            this.productId = result.data.items
              ? result.data.items[0].product_id
              : ''
          }
        } else if (result.status === 404) {
          this.$utils.notification('error', 'ไม่พบรหัสสินค้าในระบบ', 2000)
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          this.$utils.notification('error', result.response.data.message, 2000)
        }
      }
    },
    onDeleteProductCatalog(id) {
      this.productItems.splice(
        this.productItems.findIndex(element => element.id === id),
        1
      )
    },
    async onBeforeSave() {
      await this.$utils
                .confirmAlertDisplay(
                  `ต้องการเพิ่มข้อมูลใช่หรือไม่`,
                  ''
                ).then(async result => {
                  if (result) await this.onSave()
                })
    },
    async onSave() {
      if (this.productItems.length === 0) {
        this.$utils.notification(
          'error',
          this.mode === 'Delete Import Excel' ? 'ไม่มีรายการสินค้าให้ลบ' : 'ไม่มีรายการสินค้าให้ Add เพิ่ม',
          2000
        )
      } else if (this.productItems.some(s => s.is_error == true)) {
        this.$utils.notification(
          'error',
          'ไม่สามารถดำเนินการต่อได้เนื่องจากชุดยังมูลยังมีรายการที่ผิดพลาด',
          2000
        )
      } else {
        if (
           this.productItems.some(p => p.inventory_status === 'Delete')
        ) {
          this.$utils.notification(
            'error',
            'มีสินค้าสถานะ Delete อยู่ในรายการ ไม่สามารถดำเนินการต่อได้',
            2000
          )
        } else {
          let checkExist = false
          if (this.listProductItems.length > 0) {
            let skus = this.listProductItems.map(p => p.id)
            checkExist = this.productItems.some(p => skus.includes(p.id))
            if (checkExist) {
              await this.$utils
                .confirmAlertDisplay(
                  `มีข้อมูลสินค้านี้อยู่ใน Catalog แล้ว ต้องการแก้ไขข้อมูลใหม่ใช่หรือไม่`,
                  ''
                )
                .then(result => {
                  if (result) {
                    // this.$emit('hidden')
                    // this.$emit('getDataSideBar', this.productItems)
                    this.onSubmit()
                  }
                })
            } else {
              this.onSubmit()
            }
          } else {
            this.onSubmit()
          }
        }
      }
    },
    async onSubmit() {
      let products = []
      let items = JSON.parse(JSON.stringify(this.productItems.map(q => ({ product_id: q.product_id, id: q.id, pages: q.pages, remark: q.remark }))))
      items.forEach(element => {
        if (element.product_id !== undefined && element.product_id !== null && element.product_id !== '') {
          let tempListPage = []
          if (
            element.pages !== null &&
            element.pages !== undefined &&
            element.pages !== ''
          ) {
            tempListPage.push(element.pages)
          }

          var tempSku = {
            sku_id: element.id,
            pages: tempListPage,
            remark: element.remark,
          }

          if (products.length > 0) {
            if (products.some(f => f.product_id === element.product_id)) {
              let modelProduct = products.find(f => f.product_id === element.product_id)
              modelProduct.skus.push(tempSku)
            } else {
              products.push({
                product_id: element.product_id,
                skus: [tempSku],
              })
            }
          } else {
            products.push({
              product_id: element.product_id,
              skus: [tempSku],
            })
          }
        }
      })
      this.model.products = products
      this.isLoading = false
      console.log("this.model", this.model)
      this.model.mode = this.modeData
      let result = await productCatalogService.updateProductCatalogAsync(
        this.model.id,
        this.model
      )
      if (result.status && result.status === 204) {
        this.isLoadProduct = false
        if (this.modeData === 'Delete') {
          this.$utils.notification('success', 'ลบข้อมูลสำเร็จ', 1500)
          this.$emit('onSave', null)
        } else {
          this.$utils.notification('success', 'แก้ไขข้อมูลสำเร็จ', 1500)
          this.$emit('onSave', this.productItems)
        }
        
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
        this.$emit('onSave', null)
      } else {
        this.$utils.notification('error', "เกิดข้อผิดพลาด", 2000)
        this.$emit('onSave', null)
      }
      this.onClear()
      // this.second =  moment().diff(this.start, "seconds")
    },
    onClear() {
      this.productId = ''
      this.typeId = ''
      this.typeName = ''
      this.catalogId = ''
      this.catalogName = ''
      this.reloadCatalogType = false
      this.reloadCatalog = false

      this.file = null
      this.filter = {
        name: '',
      }
      this.searchProductCatalog = null
      this.productItems = []
      this.tempProductItems = []
      this.pages = null
      this.remark = null

      this.$nextTick(() => {
        this.reloadCatalogType = true
        this.reloadCatalog = true
      })
    },
  },
}
</script>
